import React from 'react'
import { Grid, Button } from '@material-ui/core'

import { List } from './components'

import { useTitle } from 'utils'
import { makeStyles } from '@material-ui/styles';
import PosterEvaluationIcon from '../../components/PosterEvaluationIcon';

const useStyles = makeStyles(theme => ({
  card: {
    position: 'relative',
    height: 512,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: (theme.palette.type === 'dark') ? '#333' : '#fff',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
}))

const listLayout = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 6,
  xl: 6
}

const formLink = "https://docs.google.com/forms/d/e/1FAIpQLSfG3TpmT8taWmv83zrrvDrAX2mxMqE9dvIu_7D7s6Kx-L4eBQ/viewform?usp=pp_url&entry.2016251708=";

function Favoritos({ favorites, handleFavoriteButton, handleShowNotification, handleBookmarksButton }) {
  const classes = useStyles()
  useTitle('PSE-2019 | Poster Evaluation')

  const handleSendVote = (e) => {
    console.log(e)
    if (favorites.length < 3) {
      handleShowNotification({message: 'You must have three works before send your vote!'})
      return
    }
    if (favorites.length > 3) {
      handleShowNotification({message: 'You can only vote for the three best posters.'})
      return
    }
    const fieldID2 = "&entry.1984882866="
    const fieldID3 = "&entry.487898500="
    const id1 = favorites[0].ID
    const id2 = favorites[1].ID
    const id3 = favorites[2].ID
    const completeUrl = formLink + id1 + fieldID2 + id2 + fieldID3 + id3
    window.open(completeUrl, '_blank')
    return
  }

  return (
    <>
      <div className={classes.container}>
      <p>
        Please, select three best posters to vote. You can remove a poster from list using the (<PosterEvaluationIcon/>) button.
      </p>
      <Button variant="contained" className={classes.button}
        target='_blank'
        rel="noreferrer"
        onClick={handleSendVote}
      >Send my Vote!
      </Button>
      <Grid container spacing={32} style={{ marginTop: '5px' }} key="fdsfds">
        {favorites.length > 0 ? (favorites.map((work, key) => (
          <Grid item key={`${key}-${work.ID}`} {...listLayout} style={{ padding: '5px 5px' }}>
            <List {...work}
              favorited={work.favorited}
              // bookmarked={work.bookmarked}
              handleFavoriteButton={handleFavoriteButton}
              // handleBookmarksButton={handleBookmarksButton}
            />
          </Grid>
        ))) : (
          <>
            <p style={{ width: '100%', textAlign: 'center' }}>Currently your rank is empty.</p>
            <p style={{ width: '100%', textAlign: 'center' }}>Please, select the three best poster then click on "send my vote".</p>
          </>
        )
        }
      </Grid>
    </div>
    </>
  )
}

export default Favoritos
